// Structure wizard

.structureSetup {
  display: grid;
  gap: 14px;
  max-width: 640px;
  margin-bottom: 18px;
}

.structureLabel {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
}

.categoryList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;

  li {
    display: flex;
    align-items: center;
    gap: 4px;

    > :first-child {
      flex: 1 1 auto;
    }
  }
}

.sharePointOrganizer {
  overflow: hidden;
  padding: 1em;
  color: "[theme:bodyText, default: #323130]";
  color: var(--bodyText);
}

.header {
  margin-bottom: 16px;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.subtitle {
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.selector {
  margin-bottom: 20px;
}

.selectorRow {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.libraryDropdown {
  min-width: 260px;
  flex: 0 1 360px;
}

.sectionTitle {
  font-size: 18px;
  font-weight: 600;
  margin: 20px 0 10px;
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}

.stat {
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-radius: 6px;
  padding: 10px 14px;
}

.statLabel {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.statValue {
  font-size: 22px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.summary {
  margin-bottom: 8px;
}

.treePanel {
  margin-top: 8px;
}

.tree {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-radius: 6px;
  max-height: 600px;
  overflow: auto;
}

.treeRow {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding-right: 12px;
  border-bottom: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border-bottom: 1px solid var(--bodyDivider);

  &:last-child {
    border-bottom: none;
  }
}

.treeToggle {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  padding: 4px 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
}

.treeChevron {
  width: 16px;
  font-size: 10px;
  flex: none;
}

.treeIcon {
  flex: none;
  color: "[theme:themePrimary, default: #0078d4]";
  color: var(--themePrimary);
}

.treeName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 auto;
  min-width: 0;
}

.treeMeta {
  flex: none;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.tabs {
  margin-top: 20px;
}

.sectionCount {
  font-weight: 400;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.issueCards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
}

.issueCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-left: 4px solid "[theme:themePrimary, default: #0078d4]";
  border-left: 4px solid var(--themePrimary);
  border-radius: 6px;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: "[theme:themePrimary, default: #0078d4]";
    border-color: var(--themePrimary);
  }

  &:disabled {
    cursor: default;
  }
}

.issueCardSelected {
  outline: 2px solid "[theme:themePrimary, default: #0078d4]";
  outline: 2px solid var(--themePrimary);
  outline-offset: -1px;
}

.issueCardClear {
  border-left-color: "[theme:bodyDivider, default: #edebe9]";
  border-left-color: var(--bodyDivider);
  opacity: 0.7;
}

.issueCardLabel {
  font-size: 13px;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.issueCardCount {
  font-size: 24px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.issueList {
  margin-top: 8px;
}

.issueListDescription {
  margin: -4px 0 12px;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.issues {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-radius: 6px;
}

.issue {
  padding: 10px 14px;
  border-bottom: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border-bottom: 1px solid var(--bodyDivider);

  &:last-child {
    border-bottom: none;
  }
}

.issueHeader {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.issueMessage {
  min-width: 0;
  overflow-wrap: anywhere;
}

.severity {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid currentColor;
}

.severity_high {
  color: #a4262c;
}

.severity_medium {
  color: #8a6100;
}

.severity_low {
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.issueItems {
  list-style: none;
  margin: 6px 0 0;
  padding: 0 0 0 4px;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 24px;
    overflow-wrap: anywhere;
  }
}

// Organization plan

.plan {
  margin-top: 8px;
}

.planSummary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin: -4px 0 14px;
  padding: 0;
  list-style: none;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

.planToolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 16px 0 8px;
}

.planProgress {
  margin-right: auto;
  font-variant-numeric: tabular-nums;
}

.planFilters {
  margin-bottom: 12px;
}

.changes {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.change {
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-left: 4px solid "[theme:bodyDivider, default: #edebe9]";
  border-left: 4px solid var(--bodyDivider);
  border-radius: 6px;
  padding: 12px 16px;
}

.changeApproved {
  border-left-color: #107c10;
}

.changeRejected {
  border-left-color: #a4262c;
  opacity: 0.75;
}

.changeHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.changeType {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.bucket {
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid currentColor;
}

.bucketHigh {
  color: #107c10;
}

.bucketMedium {
  color: #8a6100;
}

.bucketLow {
  color: #a4262c;
}

.bucketInput {
  color: "[theme:themePrimary, default: #0078d4]";
  color: var(--themePrimary);
}

.changeStatus {
  margin-left: auto;
  font-size: 13px;
  font-weight: 600;
}

.changeTitle {
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.changePaths {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 2px 12px;
  margin: 8px 0;

  dt {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: "[theme:bodySubtext, default: #605e5c]";
    color: var(--bodySubtext);
    padding-top: 2px;
  }

  dd {
    margin: 0;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 13px;
    overflow-wrap: anywhere;
  }
}

.changeReason {
  margin: 6px 0 10px;
}

.changeEdit {
  margin: 8px 0;
  max-width: 560px;
}

.changeActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

// Before / after

.compareToolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.compare {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  margin-top: 10px;
}

.compareColumn {
  min-width: 0;
}

.compareHeader {
  display: flex;
  align-items: center;
  gap: 4px;
}

.compareTitle {
  margin: 0 auto 0 0;
  font-size: 15px;
  font-weight: 600;
}

.mark {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 999px;
  color: #ffffff;
}

.markMoved {
  background: #0078d4;
}

.markRenamed {
  background: #8764b8;
}

.markQuarantined {
  background: #8a6100;
}

.markMerged {
  background: #107c10;
}

// Apply panel

.applyNotes {
  list-style: none;
  padding: 0;
  margin: 14px 0;

  li {
    display: flex;
    gap: 10px;
    align-items: baseline;
    margin: 8px 0;
  }
}

.applyHeading {
  margin: 18px 0 6px;
  font-size: 15px;
}

.applyList {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 8px 0;
    border-bottom: 1px solid "[theme:bodyDivider, default: #edebe9]";
    border-bottom: 1px solid var(--bodyDivider);
    overflow-wrap: anywhere;
  }
}

.applyProblem {
  font-size: 13px;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
}

// History

.historyOps {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
  border-top: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border-top: 1px solid var(--bodyDivider);
}

.historyOp {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  padding: 6px 0;
  font-size: 13px;
  border-bottom: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border-bottom: 1px solid var(--bodyDivider);
}

.historyOpAction {
  flex: none;
  min-width: 96px;
  font-weight: 600;
}

.historyOpPath {
  flex: 1 1 280px;
  min-width: 0;
  overflow-wrap: anywhere;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
}

.changeNote {
  margin: -4px 0 10px;
  padding: 6px 10px;
  border-left: 3px solid "[theme:themePrimary, default: #0078d4]";
  border-left: 3px solid var(--themePrimary);
  background: rgba(0, 120, 212, 0.06);
  font-size: 13px;
}

// Tags

.tagTableWrap {
  overflow-x: auto;
  border: 1px solid "[theme:bodyDivider, default: #edebe9]";
  border: 1px solid var(--bodyDivider);
  border-radius: 6px;
}

.tagTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th, td {
    padding: 6px 8px;
    text-align: left;
    vertical-align: middle;
    border-bottom: 1px solid "[theme:bodyDivider, default: #edebe9]";
    border-bottom: 1px solid var(--bodyDivider);
  }

  th {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  td {
    min-width: 120px;
  }
}

.tagFile {
  min-width: 220px;
  max-width: 320px;
  overflow-wrap: anywhere;
}

.tagReason {
  margin-top: 2px;
  font-size: 12px;
  color: "[theme:bodySubtext, default: #605e5c]";
  color: var(--bodySubtext);
  white-space: normal;
}

.tagYear {
  min-width: 80px !important;
  width: 90px;
}
